var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"about"},[_c('about-banner'),_c('aboutTitleReimagining'),_c('teamSlide'),_c('aboutWeBelieve'),_c('aboutStory'),_c('aboutSupport'),_c('aboutBrave'),_c('aboutPress'),_c('aboutFind'),_c('contactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }